import React from "react";

function DiscussionsIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 29.243 29.248">
      <path
        d="M29.946,11.981H14.365a2.683,2.683,0,0,0-2.679,2.679V25.509a2.677,2.677,0,0,0,2.679,2.672H23.28a.768.768,0,0,1,.534.225l4.43,4.085c.246.239.654.141.654-.2V28.73c0-.422.267-.555.689-.555h.07a2.927,2.927,0,0,0,2.96-2.672V14.66A2.668,2.668,0,0,0,29.946,11.981Z"
        transform="translate(-3.375 -3.375)"
      />
      <path
        d="M12.262,10.259H24.736V5.667a2.293,2.293,0,0,0-2.292-2.292H5.667A2.293,2.293,0,0,0,3.375,5.667V17.283a2.293,2.293,0,0,0,2.292,2.292h4.3V12.551A2.3,2.3,0,0,1,12.262,10.259Z"
        transform="translate(-3.375 -3.375)"
      />
    </svg>
  );
}

export { DiscussionsIcon };
